import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {Link} from '../common/components';
import {Metadata} from '../common/metadata';

import {NavBar} from './components/NavBar';
import {APIDocPage} from './page';

import {MapSVG} from './components/home/MapSVG';
import {Banner} from './components/home/Banner';


import './stylesheets/HomePage.scss';


export class HomePage extends APIDocPage {
    logo = {
        apple: '/assets/img/about/about-us/apipartners/apple.png',
        baidu: '/assets/img/about/about-us/apipartners/baidu.png',
        discord: '/assets/img/about/about-us/apipartners/discord.png',
        facebook: '/assets/img/about/about-us/apipartners/facebook.png',
        gboard: '/assets/img/about/about-us/apipartners/gboard.png',
        linkedin: '/assets/img/about/about-us/apipartners/linkedin.png',
        messenger: '/assets/img/about/about-us/apipartners/messenger.png',
        twitter: '/assets/img/about/about-us/apipartners/twitter.png',
        whatsapp: '/assets/img/about/about-us/apipartners/whatsapp.png',
        zynga: '/assets/img/about/about-us/apipartners/zynga.png',
    };
    gif = {
        smart: 'https://media1.tenor.com/images/b06111ca4f61490fe7dc535e0250d603/tenor.gif?itemid=7713620',
    };

    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        this.title = 'GIF API - Better, Faster & Free | Get Your GIFs with Tenor';
        this.description = 'Tenor GIF API seamlessly integrates all of the best features of Tenor’s GIF library into your app. Tenor GIF API is powerful and free.';
    }
    pageInit() {
        super.pageInit();
        this.setCanonicalURL('/gifapi');
    }
    renderPage() {
        return (
            <div className="HomePage APIDocPage">
                <NavBar pageLabelPrefix='api-home'/>
                <div className="main-view">
                    <Metadata page={this}/>

                    <Banner/>

                    <div id="partners">
                        <div className="container">
                            <div className="top">
                                <h1 className="blue">
                            Why Tenor?
                                </h1>
                                <p>
                            Tenor is the API that delivers the most relevant
                            GIFs for any application, anywhere in the world. We
                            are the preferred choice for communication products
                            of all types and the fastest growing GIF service on
                            the market.
                                </p>
                            </div>
                            <div className="bottom">
                                <div className="logo-section">
                                    <img className="messenger" src={this.logo.messenger}/>
                                    <img className="linkedin" src={this.logo.linkedin}/>
                                    <img className="facebook" src={this.logo.facebook}/>
                                    <img className="whatsapp" src={this.logo.whatsapp}/>
                                    <img className="twitter" src={this.logo.twitter}/>
                                </div>
                                <div className="logo-section">
                                    <img className="zynga" src={this.logo.zynga}/>
                                    <img className="gboard" src={this.logo.gboard}/>
                                    <img className="discord" src={this.logo.discord}/>
                                    <img className="apple" src={this.logo.apple}/>
                                    <img className="baidu" src={this.logo.baidu}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="highlights">
                        <div className="container">
                            <h1>API Highlights</h1>
                            <div className="highlights-body">
                                <div className="highlights-column">
                                    <div className="highlights-item">
                                        <img src="/assets/img/api/search-white.svg"/>
                                        <div>
                                    Search across the most engaging and relevant
                                    GIFs on the internet
                                        </div>
                                    </div>
                                    <div className="highlights-item">
                                        <img src="/assets/img/api/layers-white.svg"/>
                                        <div>
                                    Rich features to ensure your users find the
                                    most precise GIF quickly
                                        </div>
                                    </div>
                                </div>
                                <div className="highlights-column">
                                    <div className="highlights-item">
                                        <img src="/assets/img/api/globe-white.svg"/>
                                        <div>
                                    Support for 30+ languages, localized content
                                    and regional content appropriateness
                                        </div>
                                    </div>
                                    <div className="highlights-item">
                                        <img src="/assets/img/api/attribution-white.svg"/>
                                        <div>
                                    Optimized to deliver GIFs that load and
                                    consume less bandwidth for every use case
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="data-driven">
                        <div className="container">
                            <div className="column left">
                                <div className="data-animation small">
                                    <div className="data-orbit-ring"></div>
                                    <img className="data-orbit" src="/assets/img/api/orbit.svg"/>
                                    <div className="data-circle outer search">
                                        <img src="/assets/img/api/search-blue.svg"/>
                                Search
                                    </div>
                                    <div className="data-circle outer upload">
                                        <img src="/assets/img/api/nil-blue.svg"/>
                                Upload
                                    </div>
                                    <div className="data-circle outer share">
                                        <img src="/assets/img/api/login-blue.svg"/>
                                Share
                                    </div>
                                    <div className="data-circle center">
                                        <img src="/assets/img/tenor-logo-white.svg"/>
                                    </div>
                                </div>
                                <div className="data-animation large">
                                    <div className="data-orbit-ring"></div>
                                    <img className="data-orbit" src="/assets/img/api/orbit.svg"/>
                                    <div className="data-circle outer search">
                                        <img src="/assets/img/api/search-blue.svg"/>
                                Search
                                    </div>
                                    <div className="data-circle outer upload">
                                        <img src="/assets/img/api/nil-blue.svg"/>
                                Upload
                                    </div>
                                    <div className="data-circle outer share">
                                        <img src="/assets/img/api/login-blue.svg"/>
                                Share
                                    </div>
                                    <div className="data-circle center">
                                        <img src="/assets/img/tenor-logo-white.svg"/>
                                    </div>
                                </div>
                            </div>
                            <div className="column right">
                                <h1 className="blue">
                            Data Driven
                                </h1>
                                <p>
                            Tenor takes a data driven approach to GIFs to
                            deliver the highest share rates in the industry. Our
                            understanding of what daily users search and share
                            allow us to continually return with precision the
                            GIFs most likely to generate a share.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div id="localization">
                        <div className="background"></div>
                        <MapSVG enableAnimation={true}/>
                        <div className="container">
                            <div className="top">
                                <h1 className="blue">
                            Localization
                                </h1>
                                <p>
                            Tenor supports 35+ languages, regional content
                            appropriateness, and have localized content in all
                            the world’s largest markets.
                                </p>
                            </div>
                            <div className="bottom">
                                <div className="language-list">
                                    <div className="language-list left">
                                        <ul className="bullet-list left-align">
                                            <li>Portuguese</li>
                                            <li>English</li>
                                            <li>Spanish</li>
                                            <li>Italian</li>
                                            <li>German</li>
                                            <li>Arabic</li>
                                            <li>Russian</li>
                                            <li>French</li>
                                            <li>Albanian</li>
                                            <li>Slovak</li>
                                        </ul>
                                        <ul className="bullet-list left-align">
                                            <li>Indonesian</li>
                                            <li>Simplified Chinese</li>
                                            <li>Traditional Chinese</li>
                                            <li>Japanese</li>
                                            <li>Korean</li>
                                            <li>Hindi </li>
                                            <li>Turkish</li>
                                            <li>Dutch</li>
                                            <li>Bengali</li>
                                            <li>Tagalog</li>
                                        </ul>
                                    </div>
                                    <div className="language-list right">
                                        <ul className="bullet-list left-align">
                                            <li>Hebrew</li>
                                            <li>Finnish</li>
                                            <li>Swedish</li>
                                            <li>Danish</li>
                                            <li>Czech</li>
                                            <li>Polish</li>
                                            <li>Romanian</li>
                                            <li>Malay</li>
                                            <li>Cantonese</li>
                                            <li>Urdu</li>
                                        </ul>
                                        <ul className="bullet-list left-align">
                                            <li>Norwegian (Bokmal)</li>
                                            <li>Norwegian (Nynorsk)</li>
                                            <li>Catalan</li>
                                            <li>Greek</li>
                                            <li>Hungarian</li>
                                            <li>Thai</li>
                                            <li>Farsi</li>
                                            <li>Ukrainian</li>
                                            <li>Croatian</li>
                                            <li>Vietnamese</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="fast-loading">
                        <div className="container">
                            <div className="top">
                                <h1 className="blue">Fastest-loading in the industry</h1>
                                <p>
                            Tenor’s GIF API delivers GIFs in the smallest
                            file-sizes in the industry while preserving overall
                            quality.
                                </p>
                            </div>
                            <div className="bottom">
                                <div className="left">
                                    <div className="item">
                                        <img src={this.gif.smart} className="gif mobile"/>
                                        <div className="description">
                                            <div>Tinygif (mobile)</div>
                                            <div>215 KB</div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <img src={this.gif.smart} className="gif micro"/>
                                        <div className="description">
                                            <div>Nanogif</div>
                                            <div>77 KB</div>
                                        </div>
                                        <div className="description">(emerging markets mobile)</div>
                                    </div>
                                </div>
                                <div className="right">
                                    <div className="item">
                                        <img src={this.gif.smart} className="gif raw"/>
                                        <div className="description">
                                            <div>Raw</div>
                                            <div>1,472 KB</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="footer">
                        <div className="container">
                            <div className="top">
                                <div className="column">
                                    <h2>300+ Million</h2>
                                    <h5>Daily Search Requests</h5>
                                </div>
                                <div className="column">
                                    <h2>300+ Million</h2>
                                    <h5>Monthly Active Users</h5>
                                </div>
                                <div className="column">
                                    <h2>450+ Million</h2>
                                    <h5>Daily API Requests</h5>
                                </div>
                            </div>
                            <div className="middle">
                                <h1>Learn more about the Tenor GIF API</h1>
                                <Link className="white-button" to="https://developers.google.com/tenor/guides/quickstart" clickLabel="api-home-footer-cta">
                            View GIF API Documentation
                                </Link>
                            </div>
                            <div className="bottom">
                                <div className="links-section">
                                    <Link to={'/gifapi/documentation#quickstart'} external={true}>
                                        <img src="/assets/img/api/quickstart-white.svg" width="14" height="14"/>
                                Quickstart
                                    </Link>
                                    <Link to={'/gifapi/documentation#contentfilter'} external={true}>
                                        <img src="/assets/img/api/search-white.svg" width="14" height="14"/>
                                Content Filtering
                                    </Link>

                                    <Link to={'https://developers.google.com/tenor/guides/endpoints'} external={true}>
                                        <img src="/assets/img/api/endpoints-white.svg" width="14" height="14"/>
                                Endpoints
                                    </Link>
                                    <Link to={'https://developers.google.com/tenor/guides/migrate-from-v1'} external={true}>
                                        <img src="/assets/img/api/SDK-white.svg" width="14" height="14"/>
                                Migrating from V1
                                    </Link>
                                    <Link to={'https://developers.google.com/tenor/guides/advanced-api-controls'} external={true}>
                                        <img src="/assets/img/api/gear-white.svg" width="14" height="14"/>
                                Advanced API controls
                                    </Link>
                                </div>
                                <div className="links-section">
                                    <Link to={'/gifapi/documentation#apiterms'} external={true}>
                                        <img src="/assets/img/api/file-minus-white.svg" width="14" height="14"/>
                                API Terms
                                    </Link>

                                    <Link to={'/gifapi/documentation#responseobjects'} external={true}>
                                        <img src="/assets/img/api/layers-white.svg" width="14" height="14"/>
                                Response Objects
                                    </Link>
                                    <Link to={'/gifapi/documentation#attribution'} external={true}>
                                        <img src="/assets/img/api/attribution-white.svg" width="14" height="14"/>
                                Attribution
                                    </Link>
                                    <Link to={'/gifapi/documentation#localization'} external={true}>
                                        <img src="/assets/img/api/globe-white.svg" width="14" height="14"/>
                                Localization
                                    </Link>
                                    <Link to={'/gifapi/documentation#support'} external={true}>
                                        <img src="/assets/img/api/support-white.svg" width="14" height="14"/>
                                Support
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
